import * as React from "react"
import type { IconProps } from "../types"

const Sidebar = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="square"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M11 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H11M11 5H19C20.1046 5 21 5.89543 21 7V17C21 18.1046 20.1046 19 19 19H11M11 5V19"
        />
        <path
          fill={color}
          strokeWidth={0.5}
          d="M7 14.25C7.41421 14.25 7.75 14.5858 7.75 15C7.75 15.4142 7.41421 15.75 7 15.75C6.58579 15.75 6.25 15.4142 6.25 15C6.25 14.5858 6.58579 14.25 7 14.25ZM7 11.25C7.41421 11.25 7.75 11.5858 7.75 12C7.75 12.4142 7.41421 12.75 7 12.75C6.58579 12.75 6.25 12.4142 6.25 12L6.25391 11.9229C6.29253 11.5449 6.61183 11.25 7 11.25ZM7.07715 8.25391C7.45512 8.29253 7.75 8.61183 7.75 9C7.75 9.41421 7.41421 9.75 7 9.75C6.58579 9.75 6.25 9.41421 6.25 9C6.25 8.58579 6.58579 8.25 7 8.25L7.07715 8.25391Z"
        />
      </svg>
    )
  }
)
Sidebar.displayName = "Sidebar"

export default Sidebar